module.exports = __webpack_public_path__ + "img/youhuizhengce.7d666f74.png";